import {GameClientUserState} from '@colonist/game-base-types'
import {PlayerColor} from '@colonist/game-states'
import {StateCreator} from 'zustand'

export interface GameUserStatesSlice {
    gameUserStates: {
        userStates: GameClientUserState[]
        getUserState: (color: PlayerColor) => GameClientUserState
    }
}

export interface GameUserStatesSliceProps {
    initialUserStates: GameClientUserState[]
}

export const createGameUserStatesSlice = ({
    initialUserStates,
}: GameUserStatesSliceProps): StateCreator<GameUserStatesSlice> => () => ({
    gameUserStates: {
        userStates: initialUserStates,
        getUserState: (color: PlayerColor) => {
            const userState = initialUserStates.find((user) => user.selectedColor === color)
            if(!userState) throw new Error(`User state not found for color ${color}`)
            return userState
        },
    },
})
